// File: src/components/layouts/Core/Divider/Divider.tsx
// Purpose: Layout or container component

import React from "react";
import styled, { css, DefaultTheme } from "styled-components";
import { AppTheme } from "theme";

export interface DividerProps {
  thickness?: keyof AppTheme["border"];
  color?: keyof AppTheme["colors"];
  orientation?: "horizontal" | "vertical";
  fullWidth?: boolean;
  style?: React.CSSProperties; // ✅ Support inline styles
}

const StyledDivider = styled.div<DividerProps & { theme: AppTheme }>`
  ${({ theme, color, thickness = "md", orientation = "horizontal", fullWidth }) => css`
    background-color: ${color ? theme.colors[color] : theme.colors.divider};
    height: ${orientation === "horizontal" ? theme.border[thickness] : "100%"};
    width: ${orientation === "vertical" ? theme.border[thickness] : fullWidth ? "100%" : "auto"};
    margin: ${theme.spacing.xs} 0;
  `}
`;

export const Divider: React.FC<DividerProps> = ({
  thickness = "md",
  color = "divider",
  orientation = "horizontal",
  fullWidth = false,
  style
}) => {
  return (
    <StyledDivider
      thickness={thickness}
      color={color}
      orientation={orientation}
      fullWidth={fullWidth}
      style={style}
    />
  );
};